import React, {useLayoutEffect, useState} from "react";
import axios from "axios";
import EhrazWaiting from "./EhrazWaiting";
import Ehraz from "./Ehraz";
import MangeDashboard from "./MangeDashboard";
import Loading from "../login/Loading";
import EhrazAccept from "./EhrazAccept";
import EhrazReject from "./EhrazReject";
import { toast } from "react-toastify";


const BASEURL = 'https://api.sinatether.com/Auth/Ehraz/';

export default function ManageEhraz (){

    const [ehraz,setehraz] = useState('')
    let phone = sessionStorage.getItem('user')
    let token = localStorage.getItem('TOKEN')
    const [message,setmessage] = useState('')




    useLayoutEffect(() => {

             console.log(token)
             console.log(phone)
              axios.get(BASEURL, {
                    params:{phone},
                     withCredentials:true
              }).then((response)=> {
                  console.log(response)
                 let  st = response.data['state']
                  if (st) {
                        setmessage(response.data['message'])
                        setehraz(st)

                  }
              }).catch((error)=>{
                  if (error){
                    if (error.response.status === 400){
                        toast.dismiss()
                        toast.error("نشست شما منقضی شده است مجددا وارد شوید")
                    }
                  }
              })

    }, [])

    function renderElement(){
                if(ehraz == 'accept')
                {
                    return <EhrazAccept/>

                }
                if (ehraz == 'waiting'){
                    return <EhrazWaiting/>
                }
                if (ehraz == 'NotSending'){
                    return <Ehraz/>
                }
                if (ehraz == 'reject'){
                    return <EhrazReject message={message}/>
                }



                return <MangeDashboard><Loading/></MangeDashboard>

        }




    return(

        <>
                {renderElement()}


        </>

    )
}